import React, { Component, useState, useEffect } from "react";
import { connect, useSelector } from "react-redux";
import axios from "axios";

import { Layout, Row, Col, Table, message, Input } from "antd";
import moment from "moment-timezone";
import numberFormat from "./../../utils/numberFormat";

import { chunk, sumBy, uniq } from "lodash";
import converter from "number-to-words";
import { addKeysToArray, getSignatories } from "../../utils/utilities";
import round from "../../utils/round";
import {
  getDateTimeNow,
  edit,
  onChange,
  onDeleteItem,
} from "../../utils/form_utilities";
import isEmpty from "../../validation/is-empty";
import classnames from "classnames";

import { useLocation, useParams } from "react-router-dom";

const { Content } = Layout;

const url = "/api/check-vouchers/";
const date_fields = ["date", "check_date"];

export default function CheckPrintout({
  match,
  reprint = false,
  duplicate = false,
}) {
  const auth = useSelector((state) => state.auth);

  const initialValues = {
    _id: null,
    rr_no: null,
    date: moment(),
    supplier: null,
    warehouse: auth.user?.warehouse,
    remarks: "",
    items: [],

    purchase_order: null,
    stock_release: null,
    sales_return: null,
    customer: null,
  };

  const initialPositions = {
    name: "",
    check_name_left: "",
    check_name_top: "",
    check_date_left: "",
    check_date_top: "",
    check_day_left: "",
    check_day_top: "",
    check_year_left: "",
    check_year_top: "",
    words_left: "",
    words_top: "",
    amount_left: "",
    amount_top: "",
  };

  const [state, setState] = useState({});
  const [settings, setSettings] = useState({
    key: "",
    value: [
      {
        ...initialPositions,
      },
    ],
  });
  const [position_state, setPositionState] = useState(initialPositions);
  const [date, setDate] = useState(null);

  const [heading_state, setHeadingState] = useState({});
  const [row_selected, setRowSelected] = useState(false);
  const [row_index, setRowIndex] = useState(null);
  const params = useParams();

  useEffect(() => {
    axios.get("/api/account-settings/check-settings").then((response) => {
      if (response.data) {
        setSettings(response.data);
      }
    });

    return () => {};
  }, []);

  useEffect(() => {
    getSignatories().then((records) => {
      setState((prevState) => ({
        ...prevState,
        ...records,
      }));
    });

    const listener = window.addEventListener("afterprint", (event) => {
      axios
        .post(`${url}${params.id}/print-status`, {
          user: auth.user,
        })
        .then((response) => {
          edit({
            record: { _id: response.data._id },
            setState,
            url,
            date_fields,
          });
        });
    });

    const before_print_listener = window.addEventListener(
      "beforeprint",
      (event) => {
        event.preventDefault();
        if (isEmpty(auth.user)) {
          alert(
            "The system is not able to track your user. Please log-out and log-in again."
          );
          window.close();
        }
      }
    );

    getDateTimeNow()
      .then((date) => setDate(date))
      .catch((err) =>
        message.error("There was an error getting curent date/time")
      );

    edit({
      record: { _id: params.id },
      setState,
      url: `${url}`,
      date_fields,
    });

    return () => {
      window.removeEventListener("afterprint", listener);
      window.removeEventListener("beforeprint", before_print_listener);
    };
  }, []);

  const voucher_amount = round(state.voucher_amount);
  let cents = voucher_amount?.toString().split(".")?.[1] || 0;
  cents = cents?.toString().padEnd(2, "0");

  if (cents === "00") {
    cents = "0";
  }

  const words = `**
  ${converter.toWords(voucher_amount || 0).toUpperCase()}${" "}
  AND ${cents}
  /100 PESOS ONLY **`
    .replaceAll(",", "")
    .replaceAll("-", " ");

  const onSettingsChange = ({ key, value }) => {
    const form_data = {
      key,
      value,
    };
    axios.post("/api/account-settings", form_data);
  };

  return (
    <div>
      <Content className={classnames(`inventory-print print`)}>
        <div>
          <div
            style={{
              position: "absolute",
              left:
                parseInt(position_state.check_name_left || 0, 10) + 50 || 50,
              top: parseInt(position_state.check_name_top || 0, 10) + 50,
            }}
          >
            <span className="has-text-weight-bold">{state.check_name}</span>
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: -30,
                left: 0,
                width: 50,
              }}
              type="number"
              name="check_name_left"
              value={position_state.check_name_left}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: -30,
                left: 60,
                width: 50,
              }}
              type="number"
              name="check_name_top"
              value={position_state.check_name_top}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
          </div>

          {/* MONTH */}

          <div
            style={{
              position: "absolute",
              left:
                parseInt(position_state.check_date_left || 0, 10) + 600 || 600,
              top: parseInt(position_state.check_date_top || 0, 10) + 10,
            }}
          >
            <pre
              style={{
                margin: "0px",
                padding: "0px",
              }}
              className="check-date"
            >
              {moment(state.check_date)
                .format("MM")
                .toString()
                .split("")
                .join("  ")}
            </pre>
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: 0,
                left: -120,
                width: 50,
              }}
              type="number"
              name="check_date_left"
              value={position_state.check_date_left}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: 0,
                left: -60,
                width: 50,
              }}
              type="number"
              name="check_date_top"
              value={position_state.check_date_top}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
          </div>
          {/* END OF MONTH */}

          {/* DAY */}

          <div
            style={{
              position: "absolute",
              left:
                parseInt(position_state.check_day_left || 0, 10) + 700 || 700,
              top: parseInt(position_state.check_day_top || 0, 10) + 10,
            }}
          >
            <pre
              style={{
                margin: "0px",
                padding: "0px",
              }}
              className="check-date"
            >
              {moment(state.check_date)
                .format("DD")
                .toString()
                .split("")
                .join("  ")}
            </pre>
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: 20,
                left: -50,
                width: 50,
              }}
              type="number"
              name="check_day_left"
              value={position_state.check_day_left}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: 20,
                left: 5,
                width: 50,
              }}
              type="number"
              name="check_day_top"
              value={position_state.check_day_top}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
          </div>

          {/* END OF DAY */}

          {/* YEAR */}

          <div
            style={{
              position: "absolute",
              left:
                parseInt(position_state.check_year_left || 0, 10) + 700 || 700,
              top: parseInt(position_state.check_year_top || 0, 10) + 10,
            }}
          >
            <pre
              style={{
                margin: "0px",
                padding: "0px",
              }}
              className="check-date"
            >
              {moment(state.check_date)
                .format("YYYY")
                .toString()
                .split("")
                .join("  ")}
            </pre>
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: 0,
                left: 80,
                width: 50,
              }}
              type="number"
              name="check_year_left"
              value={position_state.check_year_left}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: 0,
                left: 150,
                width: 50,
              }}
              type="number"
              name="check_year_top"
              value={position_state.check_year_top}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
          </div>

          {/* END OF YEAR */}

          <div
            style={{
              position: "absolute",
              left: parseInt(position_state.words_left || 0, 10) + 50 || 50,
              top: parseInt(position_state.words_top || 0, 10) + 70,
            }}
          >
            <span className="condensed">{words}</span>
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: 25,
                left: 0,
                width: 50,
              }}
              type="number"
              name="words_left"
              value={position_state.words_left}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: 25,
                left: 60,
                width: 50,
              }}
              type="number"
              name="words_top"
              value={position_state.words_top}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
          </div>

          <div
            style={{
              position: "absolute",
              left: parseInt(position_state.amount_left || 0, 10) + 600 || 600,
              top: parseInt(position_state.amount_top || 0, 10) + 50,
            }}
          >
            <span className="has-text-weight-bold">
              **{numberFormat(state.voucher_amount)}**
            </span>
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: 0,
                left: 200,
                width: 50,
              }}
              type="number"
              name="amount_left"
              value={position_state.amount_left}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
            <input
              className="do-not-print"
              style={{
                position: "absolute",
                top: 0,
                left: 260,
                width: 50,
              }}
              type="number"
              name="amount_top"
              value={position_state.amount_top}
              onChange={(e) => {
                onChange({
                  key: e.target.name,
                  value: e.target.value,
                  setState: setPositionState,
                });
              }}
            />
          </div>
        </div>
        <div
          className="do-not-print"
          style={{
            position: "absolute",
            top: 300,
            left: 300,
            width: "25%",
          }}
        >
          <Table
            dataSource={addKeysToArray(settings.value)}
            columns={[
              {
                title: "Settings",
                dataIndex: "name",
                render: (value, record, index) => (
                  <input
                    type="text"
                    step={0.01}
                    name="name"
                    value={value}
                    onChange={(e) => {
                      const value = e.target.value;
                      setSettings((prevState) => {
                        let items = [...prevState.value];

                        items[index] = {
                          ...items[index],
                          name: value,
                        };

                        return {
                          ...prevState,
                          value: [...items],
                        };
                      });
                    }}
                  />
                ),
              },
              {
                title: "",
                key: "action",
                width: 30,
                align: "center",
                render: (text, record, index) => (
                  <span
                    onClick={() => {
                      if (row_selected) {
                        return;
                      }
                      if (settings.value.length != 1) {
                        onDeleteItem({
                          field: "value",
                          index,
                          setState: setSettings,
                        });
                      }
                    }}
                  >
                    {/* <i className="fas fa-trash-alt"></i> */}x
                  </span>
                ),
              },
            ]}
            pagination={false}
            onRow={(record, index) => {
              return {
                onDoubleClick: (e) => {
                  setPositionState(record);
                  setRowSelected(true);
                  setRowIndex(index);
                },
              };
            }}
            rowClassName={(record, index) => {
              if (row_index === index) return "row-is-selected";
            }}
          />
          <div className="field is-grouped">
            <span
              className="button is-small m-t-1 control"
              disabled={!row_selected}
              onClick={() => {
                if (!row_selected) {
                  return;
                }
                setSettings((prevState) => {
                  let items = [...prevState.value];

                  items[row_index] = {
                    name: items[row_index].name,
                    ...position_state,
                  };

                  onSettingsChange({
                    key: "check-settings",
                    value: items,
                  });

                  return {
                    ...prevState,
                    value: items,
                  };
                });
                setRowSelected(false);
                setPositionState(initialPositions);
              }}
            >
              Save
            </span>
            <span
              className="button is-small m-t-1 control"
              disabled={row_selected}
              onClick={(e) => {
                if (row_selected) {
                  return;
                }
                setRowSelected(false);
                setSettings((prevState) => {
                  const items = [...prevState.value];

                  items.push({
                    ...initialPositions,
                  });

                  return {
                    ...prevState,
                    value: items,
                  };
                });
              }}
            >
              Add Setting
            </span>
          </div>
        </div>
      </Content>
    </div>
  );
}
